/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// Internal Imports
import { action } from '@ember/object';

export default class DeleteLedgerItem extends Component {
  // Services
  @service
  store;

  @service
  strings;

  @tracked
  dialogOpen = false;
  @tracked
  deleteInProgress = false;
  @tracked
  errorMessage = '';
  ledgerItem = null;

  @tracked
  lineItemCount;

  onDelete() {}

  @action
  toggleDialog() {
    this.store
      .query('finance/line-item', { ledgerItemId: this.ledgerItem.id })
      .then((lineItems) => {
        this.lineItemCount = lineItems.length;
        this.toggleProperty('dialogOpen');
      });
  }

  @action
  confirmDelete(confirmed) {
    return new Promise((resolve, reject) => {
      if (confirmed) {
        // Deletion confirmed; actually delete the record.
        this.deleteInProgress = true;

        // Delete record (locally + pushed to server).
        return this.ledgerItem
          .destroyRecord()
          .then(resolve)
          .catch((err) => {
            reject(err);
          });
      } else {
        resolve();
      }
    })
      .then(() => {
        // A successful destroyRecord() removes the ledger item from the
        // store, which immediately tears down this row (and this
        // component) via the list's {{#each}}. onDelete still needs to
        // run either way (the parent list needs the notification), but
        // this component's own properties can't be set once destroyed.
        if (!this.isDestroying && !this.isDestroyed) {
          // Tidy up / close dialog.
          this.dialogOpen = false;
        }
        // Perform any onDelete passed to us
        if (confirmed) {
          this.onDelete();
        }
      })
      .catch((err) => {
        if (this.isDestroying || this.isDestroyed) {
          return;
        }
        this.handleError(err);
      })
      .then(() => {
        if (this.isDestroying || this.isDestroyed) {
          return;
        }
        this.deleteInProgress = false;
      });
  }

  handleError(err) {
    if (!isEmpty(err.errors)) {
      if (!isEmpty(err.errors.msg)) {
        this.errorMessage = err.errors.msg;
      } else if (!isEmpty(err.errors[0])) {
        let error = err.errors[0];
        if (!isEmpty(error.detail)) {
          this.errorMessage = error.detail;
        }
      }
    } else {
      this.errorMessage = err.message;
    }
  }
}
